// 基础 website 级 Schema.org 配置
export const SITE_NAME = "汗汗漫画";
export const SITE_URL = "https://hanhancomic.com";
export const SITE_DESCRIPTION = "汗汗漫画提供最全的下拉式韩漫和免费下拉式漫画在线观看，喜欢看漫画的朋友们可以自由在上面阅读韩漫。";
export const SITE_KEYWORDS = "韩国漫画,最全的下拉式韩漫,免费下拉式漫画在线观看,汗汗漫画";
export const SITE_LOGO = `${SITE_URL}/logo.png`;

export const NAV_LINKS = [
  { label: "首页", href: "/" },
  { label: "分类", href: "/category/all" },
  { label: "关于我们", href: "/about" },
];

export const CATEGORIES = [
  { key: "all", label: "全部分类" },
  { key: "hot", label: "热门推荐" },
  { key: "romance", label: "恋爱甜宠" },
  { key: "fantasy", label: "奇幻冒险" },
  { key: "action", label: "热血动作" },
  { key: "mystery", label: "悬疑推理" },
  { key: "comedy", label: "搞笑日常" },
  { key: "harem", label: "后宫恋爱" },
  { key: "drama", label: "剧情深度" },
];